import React from 'react'
import { connect } from 'react-redux'

import { dismissMessage } from './messagesListActionCreators'

import MessagesList from '../../../SharedComponents/UserMessaging/MessagesList'

const mapStateToProps = state => ({
  messages: state.ui.messages
});

const mapDispatchToProps = dispatch => ({
  onDismiss: (id) => dispatch(dismissMessage(id))
})

const MessagesListContainer = connect(mapStateToProps, mapDispatchToProps)(MessagesList)

export default MessagesListContainer